<div (offClick)="toggle(false)"
     [offClickOff]="!openState.value"
     class="b-t b-col-4 b-b pos-relative">
    <!-- heading -->
    <div class="p-l-4 p-r-4 p-t-5 p-b-5 flex flex-justify-between cursor-pointer col-1 bg-col-w"
         (click)="toggle()">
        <!-- title -->
        <div class="flex-grow w-12 s1">
            @if (titleTpl) {
            <ng-container *ngTemplateOutlet="titleTpl"></ng-container>
            }
        </div>
        <!-- icon -->
        <div [lineHeightBy]="'s1'">
            <i [toggleClassBy]="openState"
               [toggleClass]="'!icon-chevron-down icon-chevron-up'"></i>
        </div>
    </div>

    <!-- body -->
    <div class="pos-absolute m-t--1 w-12"
         [ngClass]="'z-' + bodyZIndex || 'z-1'">
        <div [hideUp]="openState">
            <div class="b-col-4 b-b bg-col-w">
                @for (option of options; track $index; let last = $last) {
                <div class="cursor-pointer p-t-1 p-b-3 p-l-4 p-r-4 p1"
                     [class.p-b-5]="last"
                     (click)="pick(option);">
                    @if (optionTpl) {
                    <ng-container *ngTemplateOutlet="optionTpl; context: { $implicit: option }"></ng-container>
                    }
                </div>
                }
            </div>
        </div>
    </div>
</div>
